import React, { ReactElement } from 'react';
import { LoaderOverlay } from 'mesh-component-library';
import { useLoadingModal } from '../../../redux/hooks/useLoadingModal';

export const LoadingModal = (): ReactElement => {
    const { isVerifying } = useLoadingModal();

    return (
        <LoaderOverlay
            isHidden={!isVerifying}
            facts={['Verifying claim information']}
            title=""
            data-testid="loader-overlay-spinner"
        />
    );
};

export default LoadingModal;
